// @ts-ignore TS7053
export default {
  mountPoint: "ea-pricecalculator-mountpoint",
};
